import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton, Tooltip, TooltipTrigger } from "@react-spectrum/s2";
import { ChevronLeft } from '../icons/s2';

export interface BackButtonProps {
  onPress: () => void;
  'aria-label'?: string;
}

/**
 * Standard back-navigation control used across detail views (DetailToolbar, etc.).
 *
 * Spectrum icon action with a visible hover/focus affordance and accessible label.
 */
export const BackButton: React.FC<BackButtonProps> = ({
  onPress,
  'aria-label': ariaLabel,
}) => {
  const { t } = useTranslation();
  const label = ariaLabel ?? t('components.backButton.back');
  return (
    <TooltipTrigger delay={0}>
      <ActionButton isQuiet onPress={onPress} aria-label={label}>
        <ChevronLeft size="S" />
      </ActionButton>
      <Tooltip>{label}</Tooltip>
    </TooltipTrigger>
  );
};
